export default __webpack_public_path__ + "static/open-graph-52d3a4074cf12e6625afb28b67d7b0a7.png";